module.exports = __webpack_public_path__ + "img/menu-21.bdbd542b.jpg";